import { IAcquaintanceType } from 'APIPackage/CatalogsModule/interfaces/IAcquaintanceType';

import { IAcquaintanceTypeSelectOption } from '../interfaces/IAcquaintanceTypeSelectOption';

export const createAcquaintanceTypeSelectOption = (
  acquaintanceType: IAcquaintanceType,
): IAcquaintanceTypeSelectOption => ({
  ...acquaintanceType,
  label: acquaintanceType.name,
  value: acquaintanceType.code,
});
